import * as React from 'react';
export const weworkSvg = React.forwardRef(function weworkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.804 12.91c1.213 0 1.482 1.328 1.541 2.203H20.06c.134-1.25.706-2.203 1.744-2.203Zm3.19 2.806a.506.506 0 0 0 .511-.489c0-1.173-1.7-2.836-3.807-2.836-2.199 0-3.981 1.736-3.981 3.879 0 2.142 1.782 3.879 3.98 3.879 1.764 0 3.259-1.118 3.782-2.666h-.482c-.37.69-1.013 1.412-2.082 1.412-1.857 0-2.895-1.265-2.887-3.179h4.966Zm-7.36-3.195h-2.173v.354h.086c.958 0 1.608.974 1.241 1.858l-1.013 2.44-1.592-3.741a.4.4 0 0 1 .368-.557h.006v-.354h-3.922v.354h.053c.322 0 .614.193.74.49l.564 1.326-1.03 2.482-1.591-3.741a.4.4 0 0 1 .367-.557h.007v-.354H5.822v.354h.053c.323 0 .614.193.74.49l2.661 6.252a.709.709 0 0 0 1.308-.006l1.729-4.166 1.776 4.172a.708.708 0 0 0 1.307-.006l2.673-6.439a.471.471 0 0 0-.435-.651Zm7.4 12.514A12.694 12.694 0 0 1 16 28.777a12.696 12.696 0 0 1-9.035-3.742A12.694 12.694 0 0 1 3.223 16c0-3.413 1.329-6.622 3.742-9.035A12.694 12.694 0 0 1 16 3.223c3.413 0 6.622 1.329 9.035 3.742A12.693 12.693 0 0 1 28.777 16c0 3.413-1.329 6.621-3.742 9.035ZM28.9 10.55a13.955 13.955 0 0 0-3-4.45A13.951 13.951 0 0 0 16 2a13.956 13.956 0 0 0-9.9 4.1A13.954 13.954 0 0 0 2 16a13.953 13.953 0 0 0 4.1 9.9A13.955 13.955 0 0 0 16 30a13.95 13.95 0 0 0 9.9-4.1A13.953 13.953 0 0 0 30 16c0-1.89-.37-3.723-1.1-5.45Z',
      fill: '#252729',
    }),
  );
});
weworkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wework = {
  category: 'brand',
  colorable: false,
  name: 'wework',
  svg: weworkSvg,
};
